<div class="centered">
    <div data-test-id="errorPageContent" class="centered__content" >
        <img data-test-id="warningImage" *ngIf="errorCode!=503" src="./assets/warning.svg" width="70px" height="70px" alt="warn">
        <img data-test-id="warningImage" *ngIf="errorCode==503" src="./assets/under_maintenance.PNG" width="150px" height="134px" alt="warn">
        <p data-test-id="title" class="centered__content--error__title" >{{error.title}}</p>
        <p data-test-id="description" class="centered__content--error__description">
            <span>{{ error.description }}</span>
        </p>
    </div>
</div>